var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRedThrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.792,
    height: 13.6
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31516",
    d: "M3.103 13.6h5.594a1.353 1.353 0 001.406-1.338l.456-9.208h.876a.354.354 0 00.358-.358.359.359 0 00-.358-.364h-2.9v-1A1.276 1.276 0 007.099 0H4.688a1.271 1.271 0 00-1.425 1.332v1h-2.9a.367.367 0 00-.358.364.362.362 0 00.358.358h.888l.456 9.208A1.344 1.344 0 003.103 13.6zm.913-12.23a.639.639 0 01.709-.66h2.337a.636.636 0 01.709.66v.962H4.015zm-.847 11.508a.716.716 0 01-.715-.7L1.998 3.05h7.8l-.448 9.131a.717.717 0 01-.722.7zm.89-1.187a.279.279 0 00.3-.29l-.2-6.828a.284.284 0 00-.3-.284.284.284 0 00-.308.29l.2 6.821a.287.287 0 00.308.291zm1.844 0a.284.284 0 00.308-.29V4.58a.284.284 0 00-.308-.29.289.289 0 00-.315.29v6.821a.289.289 0 00.315.29zm1.838 0a.29.29 0 00.308-.29l.2-6.821a.285.285 0 00-.308-.3.284.284 0 00-.3.284l-.2 6.828a.28.28 0 00.3.299z",
    fill: "#fa0043"
  })));
}

export default SvgRedThrash;